import React from 'react';
import { useSelector } from 'react-redux';

import { FILE_DOWNLOAD } from '../../constants/Urls';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { ICON_CLICK_ACTIONS } from '../../form-designer/constants/runtime.constants';
import HyperLinkComponent from '../../form-designer/controls/ssHyperLink/HyperLinkComponent';
import { getAllowContentDownload } from '../../selectors/DocumentViewer';
import { isTrue } from '../../utils/commonUtils';

export const DownloadFileLink = ({
  queryString,
  fetchFileContents,
  isDocCompare = false,
  isAttachment,
}) => {
  const allowContentDownload = useSelector(getAllowContentDownload);
  const translateString = useTranslation();

  const isDownloadAvailable = isAttachment || isTrue(allowContentDownload);

  return (
    isDownloadAvailable && (
      <HyperLinkComponent
        pathname={FILE_DOWNLOAD}
        queryString={queryString}
        isAttachmentLink
        onClick={fetchFileContents}
        asButton={{ variant: 'secondary' }}
        text={translateString('Download File')}
        iconAction={ICON_CLICK_ACTIONS.DOWNLOAD}
        onRight
        isDocCompare={isDocCompare}
      />
    )
  );
};
